import React from "react";
import { connect } from "react-redux";
import { Div, List, Text } from "@vkontakte/vkui";
import styles from "./EqueuesList.style";
import { selectEqueue } from "../../../redux/actions/selectedEqueueAction";
import { setActivePanel } from "../../../redux/actions/panelsActions";
import { panels } from "../../../variables";
import SimpleEqueue from "../SimpleEqueue";

const EqueuesList = ({ items, switchToNextPanel, selectEqueue }) => {
  const onEqueueClick = (equeue) => {
    selectEqueue(equeue.id);
    switchToNextPanel();
  };

  return (
    <>
      {items ? (
        <Div
          style={{
            padding: "0",
          }}
        >
          <Text style={styles.listHeader}>История записей</Text>
          <List style={styles.equeuesList}>
            {items.map((equeue) => {
              return (
                <SimpleEqueue
                  key={equeue.id}
                  equeue={equeue}
                  onClick={() => onEqueueClick(equeue)}
                />
              );
            })}
          </List>
        </Div>
      ) : null}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectEqueue: (id) => dispatch(selectEqueue(id)),
    switchToNextPanel: () => dispatch(setActivePanel(panels.selectedEqueue)),
  };
};

export default connect(null, mapDispatchToProps)(EqueuesList);
